import React from "react";
import { CircleCheck } from "lucide-react";

interface ShiftStatusSectionProps {
  /** Formatted date string e.g. "Monday, 15 Jan 2024" */
  shiftDate: string;
}

export function ShiftStatusSection({ shiftDate }: ShiftStatusSectionProps) {
  return (
    <section
      id="shift-status"
      className="bg-gradient-to-br from-green-500 to-green-600 p-6 pb-8 rounded-b-[2rem] shadow-lg mb-4 relative overflow-hidden"
    >
      {/* Decorative circle-check icon - top right */}
      <div className="absolute top-0 right-0 opacity-10 pointer-events-none">
        <CircleCheck className="h-36 w-36 text-white" aria-hidden />
      </div>

      <div className="text-center mb-0 relative">
        <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
          <CircleCheck className="h-8 w-8 text-white" aria-hidden />
        </div>
        <h2 className="text-xl font-bold text-white mb-1">Shift Completed</h2>
        <p className="text-green-100 text-sm">{shiftDate}</p>
      </div>
    </section>
  );
}
